import React, { useEffect, useState } from "react";
import ToolbarHeader from "../../components/ToolbarHeader";
import WrapperWithTabs from "../../components/WrapperWithTabs";
import { tabBarOptions } from "./tabBarOptions";
import CustomButton from "../../components/CustomButton";
import useApi from "../../hooks/useApi";
import moment from "moment";
import { apiUrls } from "../../utils/api/apiUrls";
import { downloadReports } from "../../utils/helpers";
import SelectInput from "../../components/FormFields/SelectInput";
import DatePicker from "../../components/FormFields/DatePicker";
import DetailsCard from "../../components/DetailsCard";
import { useAuth } from "../../contexts/AuthContext";
import RejectModal from "../../CustomRejectModal/RejectModal";
import { toast } from "react-toastify";
import { getArrayOfSelectedStoresCode } from "../../../srcWeb/utils/helpers";

const AreaManagerRequests = () => {
  const { data = [], apiCall } = useApi();
  const { data: data1, apiCall: apiCall1 } = useApi();
  const [selectedRadio, setSelectedRadio] = useState({
    key: "Pending Request",
    value: "PENDING",
  });
  const {
    user = {},
    selectedStores,
    storeDropdownState,
    setStoreDropdownState,
  } = useAuth();
  const { storeCode = ""} = selectedStores?.storeDetails || {}

  const [isRejectVisible, setIsRejectVisible] = useState({
    isOpen: false,
    data: [],
  });
  const [startDate, setStartDate] = useState(
    moment().subtract({ days: 7 }).toDate()
  );
  const [endDate, setEndDate] = useState(new Date());
  const storeLogin = user?.userLabel == "Store";

  const onChangeRadio = (val, type) => {
    setSelectedRadio(val);
    RaiseArequestTableDataApi(startDate, endDate, type);
  };

  const onChangeDate = (dates) => {
    const [start, end] = dates;
    setStartDate(start);
    setEndDate(end);
    if (end !== null)
      RaiseArequestTableDataApi(start, end, selectedRadio.value);
  };

  useEffect(() => {
    RaiseArequestTableDataApi(startDate, endDate, selectedRadio.value);
  }, [selectedStores, user, storeCode]);

  const RaiseArequestTableDataApi = (start, end, status) => {
    // debugger
    console.log("ajldfjasldfjalskdfjasdf", selectedStores, storeCode, user)
      apiCall({
        url: apiUrls.dmsService.getRecords,
        dataToSend: {
          startDate: moment(start).startOf("d").format("YYYY-MM-DD HH:mm:ss"),
          metadataSchemaId: 13,
          endDate: moment(end || start)
            .endOf("d")
            .format("YYYY-MM-DD HH:mm:ss"),
          searchText: "",
          status: status === "PENDING" ? "PENDING" : status,
          storeCodes: getArrayOfSelectedStoresCode(selectedStores, storeDropdownState)
          // storeCodes: 
          // selectedStores?.storeDetails?.storeCode
          //   ? selectedStores?.storeDetails?.storeCode !== "All" ? [selectedStores?.storeDetails?.storeCode] : null
          //   : user.userLabel == "Store" ? null : storeCode ? [storeCode] : [selectedStores[0]?.storeCode],
        },
        method: "post",
        processData: true,
        accessor: "documents",
      });
  };

  const ImprestRequestApi = (payload, status) => {
    console.log("payload", payload);
    apiCall1({
      url: apiUrls.dmsService.approveRequest,
      dataToSend: payload,
      method: "post",
      onSuccess: () => {
        RaiseArequestTableDataApi(startDate, endDate, selectedRadio.value);
        toast.success(status);
        setIsRejectVisible({ ...isRejectVisible, isOpen: false });
      },
    });
  };

  const approveRequestHandler = (val) => {
    const {parentId = '', amount = ""} = val || {}
    // console.log("approved request handler", id);
    let payload = {
      approved: [{id: parentId, approvedAmount: amount}],
      comment: "",
      rejected: [],
      // approvedAmount: null,
    };
    ImprestRequestApi(payload, "Approved Request Successfully");
  };

  const rejectRequestHandler = (id = [], comment = "") => {
    console.log("Reject Request handler", id);
    let payload = {
      approved: [],
      comment: comment,
      rejected: id,
    };
    ImprestRequestApi(payload, "Rejected Request Successfully");
  };

  const columns = [
    {
      Header: "Head",
      accessor: "head",
    },
    {
      Header: "Date",
      accessor: "date",
      Cell: (rowData) => {
        return <div>{rowData?.date}</div>;
      },
    },
    {
      Header: "Request For",
      accessor: "request_for",
      Cell: (rowData) => {
        const value = rowData;
        if (!value) {
          return "-";
        }
        return (
          <div className="py-4">
            <div className="font-size-small">{value?.head}</div>
            {/* <div className="text-[1.4rem] text-[var(--ultraLightGray)]">
              {value?.sub_head}
            </div> */}
          </div>
        );
      },
    },
    {
      Header: "Description",
      accessor: "description",
      Cell: (rowData) => {
        const value = rowData?.description;
        return value || "-";
      },
    },
    {
      Header: "Qty",
      accessor: "qty",
      Cell: (rowData) => {
        const value = rowData?.quantity;
        return value || "-";
      },
    },
    {
      Header: "Rate (₹)",
      accessor: "rate",
      Cell: (rowData) => {
        const value = rowData?.rate;
        return value || "-";
      },
    },
    {
      Header: "Total Amount (₹)",
      accessor: "amount",
      Cell: (rowData) => {
        const value = rowData?.amount;
        let amount;
        if(typeof value == "string"){
          amount = Number(value).toFixed(2);
        } else {
          amount = value
        }
        return amount || "-";
      },
    }
  ];

  const customColumn = (status) => {
    switch (status) {
      case "APPROVED":
        return [...columns, {
          Header: "Status",
          accessor: "status",
          Cell: () => {
            return (
              <div
                className={
                  status === "APPROVED"
                    ? "font-size-medium text-[var(--textRed)]" : "font-size-medium  text-[var(--successGreen)]"
                }
              >
                {"Approved"}
              </div>
            );
          },
        }]
        break;
      case "REJECTED":
        return [...columns, {
          Header: "Status",
          accessor: "status",
          Cell: () => {
            return (
              <div
                className={
                    status === "REJECTED"
                    ? "font-size-medium text-[var(--textRed)]" : "font-size-medium  text-[var(--successGreen)]"
                }
              >
                {"Rejected"}
              </div>
            );
          },
        }]
        break;
    
      default:
        return columns
        break;
    }
  } 
  let reportData = [
    {
      sheet: "Reports",
      columns: [
        { label: "Date", value: (row) => row.date }, // Top level data
        { label: "Request For", value: (row) => row.head }, // Top level data
        // { label: "Sub Head", value: (row) => row.sub_head }, // Top level data
        { label: "Description", value: (row) => row.description }, // Top level data
        { label: "Rate", value: (row) => row.rate }, // Top level data
        { label: "Quantity", value: (row) => row.quantity }, // Top level data
        { label: "Total Amount", value: (row) => row.amount }, // Top level data
        { label: "Approval Status", value: (row) => row.approval_status }, // Top level data
      ],
      content: data,
    },
  ];

  let reportSettings = {
    fileName: selectedRadio?.key + " Reports", // Name of the resulting spreadsheet
    extraLength: 3, // A bigger number means that columns will be wider
    writeMode: "writeFile", // The available parameters are 'WriteFile' and 'write'. This setting is optional. Useful in such cases https://docs.sheetjs.com/docs/solutions/output#example-remote-file
    writeOptions: {}, // Style options from https://docs.sheetjs.com/docs/api/write-options
    RTL: false, // Display the columns from right-to-left (the default value is false)
  };

  const downloadRequestReports = () => {
    downloadReports(reportData, reportSettings);
  };

  return (
    <div className="dashboard-container">
      <ToolbarHeader
        title="View Request"
        showBack={false}
        containerClassName="mt-14"
        showStores
        // renderRight={() => {
        //   return (
        //     <CustomButton title="Raise a Request" wrapperClassName="!px-10" />
        //   );
        // }}
      />

      <div className="flex flex-col gap-y-4 mb-2">
        {/* <SelectInput
          value={{name: storeDropdownState[0]?.name || "-", storeCode: storeDropdownState[0]?.storeCode}}
          valueField="storeCode"
          labelField="name"
          onChangeFullRes={true}
          options={storeDropdownState || []}
          onChange={(val) => {
            let data = val[0];
            RaiseArequestTableDataApi(startDate, endDate, 
              selectedRadio?.value === "PENDING" ? "PENDING" : 
              selectedRadio?.value || "PENDING"
              );
            // onChangeType(data, 
            //   selectedType?.value === "ALL_REQUEST" ? null : 
            //   selectedType?.value || null
            //   )
          }}
        /> */}
        <SelectInput
          valueField="value"
          labelField="key"
          onChangeFullRes={true}
          options={[
            { key: "Pending Request", value: "PENDING" },
            { key: "Approved Request", value: "APPROVED" },
            { key: "Rejected Request", value: "REJECTED" },
          ]}
          onChange={(val) => {
            let data = val[0];
            if (data.value === "PENDING") {
              onChangeRadio(data, "PENDING");
            } else if (data.value === "APPROVED") {
              onChangeRadio(data, "APPROVED");
            } else {
              onChangeRadio(data, "REJECTED");
            }
          }}
        />
        <DatePicker
          startDate={startDate}
          endDate={endDate}
          onChange={onChangeDate}
          dateRange
        />
      </div>

      <div className="overflow-auto relative mt-4" style={{ height: "84vh" }}>
        <DetailsCard
          showGlobalSearch
          rows={customColumn(selectedRadio.value || "PENDING")}
          data={data}
          isRejectApproveButtonEnable={selectedRadio.value === "PENDING"}
          rejectHandler={(dat) => {
            let ids = dat.parentId || ""
            setIsRejectVisible({ data: [ids], isOpen: true })
          }
          }
          sendRowDataInHandler={true}
          approveHandler={(id) => approveRequestHandler(id)}
          isPartiallyActive={false}
          customRow={(row, rowData) => {
            if (row.Header === "Head") {
              return (
                <div
                  className={`min-h-[5rem] bg-[var(--darkGray2)] flex items-center justify-between px-5 text-[var(--whiteColor)] rounded-tl-[1rem] rounded-tr-[1rem]`}
                >
                  <div className="min-w-[18rem] font-size-medium">
                    {rowData?.[row?.accessor]}
                  </div>

                  {/* <FaChevronRight color="var(--whiteColor)" size={15} /> */}
                </div>
              );
            }
          }}
        />
      </div>
      <div className={`mt-4 flex items-center justify-end`}>
        {data?.length > 0 && <CustomButton
          onClick={downloadRequestReports}
          title="Download"
          wrapperClassName="border-[1px] !border-[var(--blackColor)] !bg-transparent self-end !text-[var(--blackColor)] !px-8"
        />}
      </div>
      {isRejectVisible.isOpen && (
        <RejectModal
          isModalVisible={isRejectVisible}
          title="Request"
          setIsModalVisible={setIsRejectVisible}
          rejectHandler={({ data = [], comment = "" }) => {
            const validIds = [...new Set([...data])];
            rejectRequestHandler(validIds, comment);
          }}
        />
      )}
    </div>
  );
};

export default AreaManagerRequests;
